import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { requiredProperty, invalidType, uniqueProperty, maxLength, sameAsProperty, minLength, containsNumber, maxFileSize, } from '@/helpers/mixins/LocalizationHelper';
import { MAX_FILE_SIZE } from '@/helpers/constants/app';
import { helpers } from 'vuelidate/lib/validators';
/**
 * Form Field Errors Mixin
 * Generate Field Errors and accept Vuelidate Property as argument
 */
let FormValidationsMixin = class FormValidationsMixin extends Vue {
    fieldErrors(v, label, length = '0') {
        const errors = [];
        if (!v.$dirty) {
            return errors;
        }
        if (!v.required) {
            const msg = requiredProperty(label);
            errors.push(msg);
        }
        if (v.email != null && !v.email) {
            const msg = invalidType(label);
            errors.push(msg);
        }
        if ((v.alpha != null && !v.alpha) ||
            (v.url != null && !v.url) ||
            (v.phone != null && !v.phone)) {
            const msg = invalidType(label);
            errors.push(msg);
        }
        if (v.unique != null && !v.unique) {
            const msg = uniqueProperty(label);
            errors.push(msg);
        }
        if (v.minLength != null && !v.minLength) {
            const msg = minLength(label, length);
            errors.push(msg);
        }
        if (v.maxLength != null && !v.maxLength) {
            const msg = maxLength(label, length);
            errors.push(msg);
        }
        if (v.sameAsPassword != null && !v.sameAsPassword) {
            const msg = sameAsProperty(label, 'Password');
            errors.push(msg);
        }
        if (v.containsNumber != null && !v.containsNumber) {
            const msg = containsNumber(label);
            errors.push(msg);
        }
        if (v.invalidValue != null && !v.invalidValue) {
            const msg = invalidType(label);
            errors.push(msg);
        }
        // Custom mobile number validator
        if (v.validMobileNumber != null && !v.validMobileNumber) {
            const msg = invalidType(label);
            errors.push(msg);
        }
        // TODO (for separate PR): proper handling of fileSize using humanized file
        // size (MB, kb, etc.)
        if (v.maxFileSizeExceeded != null && !v.maxFileSizeExceeded) {
            const fileSizeLabel = `${MAX_FILE_SIZE / 1000000}MB`;
            const msg = maxFileSize(label, fileSizeLabel);
            errors.push(msg);
        }
        return errors;
    }
};
FormValidationsMixin = __decorate([
    Component
], FormValidationsMixin);
export default FormValidationsMixin;
/**
 * Mobile Number Format Validator
 * Validates that mobile numbers are in [+63 ### ### ####] format
 * Used in conjunction with PhoneInput, which autoformats numbers to the above format with valid mobile numbers
 */
const validMobileNumber = helpers.regex('mobileNumber', /\+63 \d{3} \d{3} \d{4}/);
export { validMobileNumber };
